import React from "react";

const CustomButton = ({
  label,
  onClick = "",
  disabled,
  type = "button",
  subtitle,
  icon,
  buttonClass,
  labelClass,
  iconClass,

  contentLengthClass = null,
  showModifyIcon = false,
  onModifyClick = null,
  isActive = false,
}) => {
  const buttonContent = (
    <>
      <div className="d-flex gap10 t03 align-items-center justify-content-between w-100">
        <div
          className="d-flex gap10 align-items-center"
          style={{ height: "40px", minWidth: "100px" }}
        >
          {icon && <span className={`${iconClass}`}>{icon}</span>}
          <span className={labelClass}>
            {label || ""}
            <p className={contentLengthClass}>{subtitle || " "}</p>
          </span>
        </div>
        {showModifyIcon && (
          <div
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onModifyClick && onModifyClick();
            }}
            style={{
              background: "none",
              border: "none",
              color: "#707070",
              fontSize: "14px",
              cursor: "pointer",
              padding: "2px 4px",
            }}
            title="Modifier la recherche"
          >
            <svg
              height={30}
              width={30}
              viewBox="0 0 21 21"
              xmlns="http://www.w3.org/2000/svg"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke={!isActive ? "#FFFFFF" : "#e91e63"}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(3 3)"
                >
                  {" "}
                  <path
                    d="m7.5.5c.35132769 0 .69661025.02588228 1.03404495.07584411l.50785434 1.53911115c.44544792.12730646.86820077.30839026 1.26078721.53578009l1.4600028-.70360861c.5166435.39719686.9762801.86487779 1.3645249 1.388658l-.7293289 1.44720284c.2201691.39604534.3936959.82158734.5131582 1.2692035l1.5298263.5338186c.0390082.29913986.0591302.60421522.0591302.91399032 0 .35132769-.0258823.69661025-.0758441 1.03404495l-1.5391112.50785434c-.1273064.44544792-.3083902.86820077-.5357801 1.26078721l.7036087 1.4600028c-.3971969.5166435-.8648778.9762801-1.388658 1.3645249l-1.4472029-.7293289c-.39604532.2201691-.82158732.3936959-1.26920348.5131582l-.5338186 1.5298263c-.29913986.0390082-.60421522.0591302-.91399032.0591302-.35132769 0-.69661025-.0258823-1.03404495-.0758441l-.50785434-1.5391112c-.44544792-.1273064-.86820077-.3083902-1.26078723-.5357801l-1.46000277.7036087c-.51664349-.3971969-.97628006-.8648778-1.36452491-1.388658l.72932886-1.4472029c-.2203328-.39633993-.39395403-.82222042-.51342462-1.27020241l-1.52968981-.53381682c-.03892294-.29882066-.05900023-.60356226-.05900023-.91299317 0-.35132769.02588228-.69661025.07584411-1.03404495l1.53911115-.50785434c.12730646-.44544792.30839026-.86820077.53578009-1.26078723l-.70360861-1.46000277c.39719686-.51664349.86487779-.97628006 1.388658-1.36452491l1.44720284.72932886c.39633995-.2203328.82222044-.39395403 1.27020243-.51342462l.53381682-1.52968981c.29882066-.03892294.60356226-.05900023.91299317-.05900023z"
                    strokeWidth=".933"
                  ></path>{" "}
                  <circle cx="7.5" cy="7.5" r="3"></circle>{" "}
                </g>{" "}
              </g>
            </svg>
          </div>
        )}
      </div>
    </>
  );

  return (
    <button
      style={{ zIndex: "1" }}
      type={type}
      onClick={onClick}
      className={`custom-button t03 border-0 ${buttonClass} ${
        disabled ? "btn-disabled" : ""
      } ${isActive ? "active" : ""}`}
      disabled={disabled}
    >
      {buttonContent}
    </button>
  );
};

export default CustomButton;
